import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openCollapseSidebar } from "../../../feature/sidebar/sidebarSlice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import { useState } from "react";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";

import Sidebarlinks from "./Sidebarlinks";

const StyledButtonList = styled(ListItemButton)(({ theme }) => ({
  "&.Mui-selected": {
    ".MuiListItemText-primary": {
      color: "#3366ff",
    },
    ".MuiListItemIcon-root": {
      color: "#3366ff",
    },
  },
  "&:hover": {
    ".MuiListItemIcon-root": {
      color: "#598bff",
    },
    ".MuiListItemText-primary": {
      color: "#598bff",
    },
  },
}));

const SidebarItems = () => {
  const { isOpen } = useSelector((state) => state.sidebar);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isSubmenuOpen, setIsSubmenuOpen] = useState({});

  const handleCollapse = (id) => {
    setIsSubmenuOpen((prevState) => {
      return { ...prevState, [id]: !prevState[id] };
    });
  };

  const listItems = Sidebarlinks();

  return (
    <List>
      {listItems.map((listItem) => {
        return (
          <Box key={listItem.id}>
            <ListItem disablePadding sx={{ display: "block" }}>
              <StyledButtonList
                selected={
                  pathname === listItem.link ||
                  pathname === listItem.links ||
                  pathname === listItem.links2
                }
                disableRipple
                onClick={(e) => {
                  handleCollapse(listItem.id);
                  listItem.link && navigate(listItem.link);
                  // listItem.link && dispatch(toggleMobileSidebar())
                  listItem.subMenus && dispatch(openCollapseSidebar());
                }}
                sx={{
                  height: 48,
                  // py: 1.4,
                  justifyContent: isOpen ? "initial" : "center",
                  "&.Mui-selected": {
                    borderLeft: isOpen ? "none" : "5px solid #3366FF",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: isOpen ? 1 : "auto",
                    justifyContent: "center",
                    color: "#8F9BB3",
                  }}
                >
                  {listItem.icon}
                </ListItemIcon>
                <ListItemText
                  sx={{
                    opacity: isOpen ? 1 : 0,
                  }}
                  primaryTypographyProps={{
                    fontWeight: "600",
                    fontSize: "13px",
                    lineHeight: "1.5rem",
                    // color:"text.primary"
                  }}
                  primary={listItem.text}
                ></ListItemText>
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    display: !isOpen && "none",
                    justifyContent: "center",
                    color: "#8F9BB3",
                  }}
                >
                  {!listItem.subMenus ? (
                    ""
                  ) : isSubmenuOpen[listItem.id] ? (
                    <KeyboardArrowDown
                      sx={{ color: "#8F9BB3", transform: "scale(.85)" }}
                    />
                  ) : (
                    <KeyboardArrowLeft
                      sx={{ color: "#8F9BB3", transform: "scale(.85)" }}
                    />
                  )}
                </ListItemIcon>
              </StyledButtonList>
              {listItem.subMenus && (
                <Collapse
                  in={isOpen && isSubmenuOpen[listItem.id]}
                  timeout='auto'
                  unmountOnExit
                >
                  {listItem.subMenus.map((subMenu) => {
                    return (
                      <List component='div' key={subMenu.id} disablePadding>
                        <Divider variant='middle' />
                        <StyledButtonList
                          disableRipple
                          onClick={() => {
                            navigate(subMenu.link);
                            // dispatch(toggleMobileSidebar())
                          }}
                          sx={{ px: 6, height: 48 }}
                          selected={pathname === subMenu.link}
                        >
                          <ListItemText
                            primaryTypographyProps={{
                              fontWeight: "600",
                              fontSize: "13px",
                              lineHeight: "1.5rem",
                            }}
                            primary={subMenu.text}
                          />
                        </StyledButtonList>
                      </List>
                    );
                  })}
                </Collapse>
              )}
            </ListItem>
            <Divider />
          </Box>
        );
      })}
    </List>
  );
};

export default SidebarItems;
